import React from "react";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import ModalClose from "@mui/joy/ModalClose";
import DialogTitle from "@mui/joy/DialogTitle";
import DialogContent from "@mui/joy/DialogContent";
import Button from "@mui/joy/Button";

const ConfirmationModal = ({
  open,
  onClose,
  onConfirmFinalPhase,
  onUpdatePositions,
  onUpdateAcumulados,
  // onUpdateTablaSanciones,
  onUpdatePuntajeFinal,
  onQualificationToFinalPhase
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog>
        <ModalClose />
        <DialogTitle>Confirmación</DialogTitle>
        <DialogContent>
          <p>¿Qué acción desea realizar?</p>
          <div className="flex justify-end gap-2 mt-4">
            <Button variant="solid" onClick={onConfirmFinalPhase}>
              Crear Enfrentamientos
            </Button>
            <Button variant="solid" onClick={onUpdatePositions}>
              Actualizar Tabla de Posiciones
            </Button>
            <Button variant="solid" onClick={onUpdateAcumulados}>
              Actualizar Tabla de Acumulados
            </Button>
            <Button variant="solid" onClick={onUpdateAcumulados}>
              Acutalizar Acreditados
            </Button>
            <Button variant="solid" onClick={onUpdatePuntajeFinal}>
              {/* Acutalizar Tabla de Sanciones */}
              Actualizar Puntaje General
            </Button>
            <Button variant="solid" onClick={onQualificationToFinalPhase}>
              Clasificación a la Fase Final
            </Button>
          </div>
        </DialogContent>
      </ModalDialog>
    </Modal>
  );
};

export default ConfirmationModal;
